module.exports = __webpack_public_path__ + "static/img/1-1.04bcc61.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/11/eng/1-1.png
// module id = Pg07
// module chunks = 0